// Components
import { LoadingPage } from "./LoadingPage";

export const LoadingPageContainer = (props) => {
    return <LoadingPage {...props} />;
};
